import styles from './First.module.scss';
import {Socials} from "../../Socials/Socials";

export const First = ({element, random}) => {
    const sharingText = 'Как гласят легенды, декабрь – время для прогнозов. Получи предсказание от героев нового сериала 2х2';

    const sharingArray = [
        {id: 0, name: 'sharing-vk', link: `https://vk.com/share.php?url=${document.location.href}&title=${sharingText}&image=${window.location.origin}${process.env.PUBLIC_URL}/sharing/${random}.png`},
        {id: 1, name: 'sharing-tg', link: `https://t.me/share/url?url=${document.location.href}&text=${element.desc}`},
        {id: 2, name: 'sharing-ok', link: `https://connect.ok.ru/offer?url=${document.location.href}&title=${sharingText}&imageUrl=${window.location.origin}${process.env.PUBLIC_URL}/sharing/${random}.png`},
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.bg}>
                <img src={`${process.env.PUBLIC_URL}/characters/${random}.png`} alt={element.title}/>
            </div>
            <div className={styles.content}>
                <div className={styles.title}>{element.title}</div>
                <div className={styles.desc}>{element.desc}</div>
                <Socials data={sharingArray}/>
            </div>
        </div>
    )
}